import { FaLock } from "react-icons/fa";

interface DisabledLockOverlayProps {
  title: string;
  description: string;
}

export function DisabledLockOverlay({ title, description }: DisabledLockOverlayProps) {
  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-50">
      <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl border-2 border-slate-200 p-6 max-w-[280px] transform transition-all duration-300 animate-in fade-in zoom-in-95">
        <div className="flex flex-col items-center text-center space-y-3">
          <div className="w-14 h-14 text-gray-600 rounded-full bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center shadow-inner">
            <FaLock fontSize={24} />
          </div>
          <div>
            <h4 className="text-sm font-bold text-slate-800 mb-1">{title}</h4>
            <p className="text-xs text-slate-600 leading-relaxed">{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
